'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import UITextToolbarIcon from '../editor/UITextToolbarIcon';
import SimpleStyledClickable from '../editor/internal/SimpleStyledClickable';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIDropdownCaret from 'UIComponents/dropdown/UIDropdownCaret';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import styled from 'styled-components';
import { EERIE } from 'HubStyleTokens/colors';
import { pick } from '../../utils/iterables';
import StyleProtectedUIDropdown from '../style-protected/StyleProtectedUIDropdown';
import withDisabledContext from '../hoc/withDisabledContext';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledCaret = styled(UIDropdownCaret).withConfig({
  displayName: "ToolbarDropdownButton__StyledCaret",
  componentId: "d0ql1c-0"
})(["color:", ";"], EERIE);
class ToolbarDropdownButton extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      isOpen: false
    };
    this.handleOpenChange = ({
      target: {
        value: isOpen
      }
    }) => {
      const {
        onOpenChange
      } = this.props;
      if (onOpenChange) {
        onOpenChange(isOpen);
      }
      this.setState({
        isOpen
      });
    };
  }
  render() {
    const {
      tooltip,
      active,
      buttonIconName,
      disabled
    } = this.props;
    const dropdownProps = pick([...Object.keys(UIDropdown.propTypes), 'data-test-id'], this.props);
    const tooltipOpen = this.state.isOpen ? false : undefined;
    return /*#__PURE__*/_jsx(UITooltip, {
      disabled: disabled,
      title: tooltip,
      open: tooltipOpen,
      placement: "bottom",
      children: /*#__PURE__*/_jsx(StyleProtectedUIDropdown, Object.assign({}, dropdownProps, {
        disabled: disabled,
        Button: SimpleStyledClickable,
        animateOnMount: true,
        buttonText: /*#__PURE__*/_jsx(UITextToolbarIcon, {
          disabled: disabled,
          name: buttonIconName
        }),
        caretRenderer: /*#__PURE__*/_jsx(StyledCaret, {
          className: "m-x-1"
        }),
        onOpenChange: this.handleOpenChange,
        active: active
      }))
    });
  }
}
ToolbarDropdownButton.defaultProps = {
  menuWidth: 150
};
ToolbarDropdownButton.propTypes = {
  tooltip: PropTypes.string.isRequired,
  buttonIconName: PropTypes.string.isRequired,
  active: PropTypes.bool,
  menuWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onOpenChange: PropTypes.func,
  disabled: PropTypes.bool
};
export default withDisabledContext(ToolbarDropdownButton);